import { withInstall } from '../utils/index';
import _Tabs from './index.vue';
import './index.less';

export const TlbsTabs = withInstall(_Tabs);
export default TlbsTabs;
